import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DocumentMaster} from '../models/document-master';

@Component({
  selector: 'document-list',
  template: `
    <div class="row">
      <div class="col-md-12">
        <div class="row header">
          <div class="col-md-2">
            Id
          </div>
          <div class="col-md-3">
            Name
          </div>
          <div class="col-md-7">
            Details
          </div>
        </div>
          <document-detail *ngFor="let d of documents" 
                           [doc]="d"
                           [allowDelete]="allowDelete"
                           [downloading]="downloading"
                           (downloadFile)="download($event)"
                           (editFile)="edit($event)"
                           (deleteFile)="delete($event)"></document-detail>
      </div>
    </div>
  `,
  styles: []
})
export class DocumentListComponent {
  @Input() documents: DocumentMaster[];
  @Input() allowDelete: boolean;
  @Input() sortedOn: string;
  @Input() ascending: boolean;
  @Input() downloading: number;
  @Output() downloadFile: EventEmitter<number> = new EventEmitter();
  @Output() deleteFile: EventEmitter<number> = new EventEmitter();
  @Output() editFile: EventEmitter<number> = new EventEmitter();
  @Output() sortList: EventEmitter<string> = new EventEmitter();

  download(id: number) {
    this.downloadFile.emit(id);
  }

  delete(id: number) {
    this.deleteFile.emit(id);
  }

  edit(id: number) {
    this.editFile.emit(id);
  }

  sort(field: string) {
    this.sortList.emit(field);
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/document/components/document-list.ts